import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import { ref, useSlots } from 'vue';

interface Props {
  closeOutsideModal?: boolean,
  width?: number | string,
}

const cssClass = 'add-link-modal';


export default /*@__PURE__*/_defineComponent({
  __name: 'Addlink',
  props: {
    closeOutsideModal: { type: Boolean, default: false },
    width: { default: 600 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const slots = useSlots();
const $modal = ref<HTMLDialogElement | null>(null);
const handleOpen = () => {
  $modal.value?.showModal();
  document.body.style.overflow = 'hidden';
};

const handleClose = () => {
  $modal.value?.close();
  document.body.style.overflow = '';
};

const handleOutsideClick = (event: any): void => {
  if (props.closeOutsideModal && $modal.value) {
    const dialogDimensions = $modal.value.getBoundingClientRect();

    if (
      event.clientX < dialogDimensions.left
        || event.clientX > dialogDimensions.right
        || event.clientY < dialogDimensions.top
        || event.clientY > dialogDimensions.bottom
    ) {
      handleClose();
    }
  }
};

__expose({
  showModal: handleOpen,
  close: handleClose,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "$modal",
    ref: $modal,
    class: _normalizeClass([cssClass, _ctx.$attrs.class]),
    style: _normalizeStyle({ width: `${_ctx.width}px` }),
    onClick: handleOutsideClick
  }, [
    (_unref(slots).header)
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          class: _normalizeClass(`${cssClass}__header`)
        }, [
          _renderSlot(_ctx.$slots, "header")
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("main", {
      class: _normalizeClass(`${cssClass}__body`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_unref(slots).buttons)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`${cssClass}__buttons`)
        }, [
          _renderSlot(_ctx.$slots, "buttons")
        ], 2))
      : _createCommentVNode("", true)
  ], 6))
}
}

})